import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TinyColor } from '@ctrl/tinycolor';

export interface ColorPickerData {
  hex: string;
  label: string;
}

@Component({
  selector: 'app-color-picker-dialog',
  templateUrl: './color-picker-dialog.component.html',
  styleUrls: ['./color-picker-dialog.component.css']
})
export class ColorPickerDialogComponent {
  value = '#FFFFFFFF';
  format: 'hex' | 'rgb' | 'hsl' | 'hsv' = 'hex';

  constructor(
    public dialogRef: MatDialogRef<ColorPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ColorPickerData
  ) {
    this.value = this.normalizeHex(data.hex);
  }

  onConfirm(): void {
    this.dialogRef.close({
      hex: this.toHexValue(this.value),
      label: this.data.label
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  get previewHex(): string {
    return this.toHexValue(this.value);
  }

  private normalizeHex(hex: string): string {
    if (!hex) {
      return '#FFFFFFFF';
    }

    const clean = hex.replace('#', '').trim();
    if (clean.length === 6) {
      return `#${clean}FF`;
    }

    if (clean.length === 8) {
      return `#${clean}`;
    }

    const fallback = new TinyColor(hex);
    return fallback.isValid ? fallback.toHex8String() : '#FFFFFFFF';
  }

  private toHexValue(value: string): string {
    const color = new TinyColor(value);
    if (!color.isValid) {
      return 'FFFFFFFF';
    }

    return color.toHex8().toUpperCase();
  }
}
